import React from 'react'
import { Link } from 'react-router-dom'

import Navbar from '../../components/navbar_poc'
import Shape from '../../components/shape'
import ShapeTwo from '../../components/shape-two'
import Footer from '../../components/footer'

import bg1 from '../../assets/images/bg.jpg'

export default function PageTerm() {
  return (
    <>
     <Navbar/>
     
    <section className="bg-half-170 bg-light d-table w-100" style={{backgroundImage:`url(${bg1})`, backgroundPosition:'center'}}>
      <div className="bg-overlay bg-overlay-white"></div>
      <div className="container">
          <div className="row mt-5 text-center align-items-center">
              <div className="col-sm-6">
                  <div className="text-sm-start">
                      <div className="page-next-level">
                          <h4 className="title">Terms & Conditions</h4>
                          <p className="text-muted mb-0">Effective Date: May 2, 2025</p>                                        
                      </div>
                  </div>
              </div>

              <div className="col-sm-6 mt-4 mt-sm-0 pt-2 pt-sm-0">
                  <div className="page-next-level text-sm-end">
                      <ul className="page-next ps-0 mb-0">
                          <li className="list-inline-item"><Link to="/" className="text-uppercase fw-bold text-dark">Home</Link></li>
                           <li className="list-inline-item">
                              <span className="text-uppercase text-primary fw-bold">Terms & Conditions</span> 
                          </li> 
                      </ul>
                  </div>
              </div>
          </div>
      </div> 
    </section>
    <ShapeTwo/>

    <section className="section">
      <div className="container">
          <div className="row justify-content-center">
              <div className="col-12">
                  <h4>Introduction :</h4>
                  <p className="text-muted">  Welcome to the website of Pioneer One Global (POG), a DBA of Minmini Corporation.
        By accessing our website, you agree to be bound by these Terms of Use.
</p>
<h5>1. Use of Site</h5>
      <p>You agree to use this site lawfully. Do not transmit harmful or objectionable material.</p>

      <h5>2. Intellectual Property</h5>
      <p>All content is owned by Minmini Corporation or its licensors and protected by IP laws. Do not reuse without permission.</p>

      <h5>3. Limitation of Liability</h5>
      <p>We strive for accuracy but disclaim liability for any errors. Use the site at your own risk.</p>

      <h5>4. Third-Party Links</h5>
      <p>We are not responsible for the content or privacy practices of third-party websites.</p>

      <h5>5. Changes to Terms</h5>
      <p>We may update these Terms. Continued use constitutes acceptance.</p>

      <h5>6. Contact Us</h5>
      <p>Questions? Reach out at terms@pioneeroneglobal.com.</p>
   
              </div>
          </div>
      </div>
    </section>
    <Shape/>
    <Footer/>
    </>
  )
}
